import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('SW registered: ', registration);
    }).catch(registrationError => {
      console.log('SW registration failed: ', registrationError);
    });
  });
}

// Request notification permission - improved UX approach
const requestNotificationPermission = async () => {
  if ('Notification' in window && Notification.permission === 'default') {
    try {
      // We'll request this when user interacts with timer
      // This is stored here for future implementation
      console.log('Notification permission will be requested when needed');
    } catch (error) {
      console.error('Error requesting notification permission:', error);
    }
  }
};

// Lazy initialize the app
const lazyInitialize = async () => {
  await requestNotificationPermission();
};

// Main app render
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Initialize additional features after render
lazyInitialize();
